export default "__VITE_ASSET__Di3rHh9S__"